import { Box, Flex, Spacer } from '@chakra-ui/layout';
import React from 'react';

import { usePermissionGuard } from '~/core/PermissionGuard';
import { permissions as tasksPermissions } from '~/core/routes/tasks/Router';
import { Counter } from '~/packages/common-frontend/components/Counter';
import { Icon } from '~/packages/common-frontend/components/icons';
import { GlobalNavRouterLinkItemWithUpsell } from '~/packages/common-frontend/layout';
import { useLayoutContext } from '~/packages/common-frontend/layout/LayoutProvider';
import { useGetIncompleteTasksCountQuery } from '~/packages/tasks/requests/tasks.gql.generated';

export const TasksGlobalNavRouterLinkWithUpsell = () => {
  const { globalNavOpen } = useLayoutContext();
  const { data: incompleteTasksCountData } = useGetIncompleteTasksCountQuery({
    skip: usePermissionGuard(tasksPermissions) === 'deny',
  });

  const incompleteTasksCount =
    incompleteTasksCountData?.getIncompleteTasksCount ?? 0;

  return (
    <GlobalNavRouterLinkItemWithUpsell
      permissions={tasksPermissions}
      GlobalNavRouterLinkItemProps={{
        to: '/tasks',
        label: (
          <Flex alignItems="center" width="100%">
            Tasks
            <Spacer />
            {globalNavOpen && incompleteTasksCount > 0 && (
              <Counter
                count={incompleteTasksCount}
                colorScheme="v2-aurora"
                increaseContrast
                size="md"
              />
            )}
          </Flex>
        ),
        icon: (
          <Box position="relative">
            <Icon icon="list" />
            {!globalNavOpen && (
              <Box
                position="absolute"
                top="-2px"
                right="-6px"
                width="6px"
                height="6px"
                borderRadius="full"
                bg="red"
              />
            )}
          </Box>
        ),
        'aria-label': `Tasks${
          incompleteTasksCount ? ` (${incompleteTasksCount})` : ''
        }`,
      }}
    />
  );
};
